import drop from 'lodash/drop'
import take from 'lodash/take'
import shuffle from 'lodash/shuffle'

export function getCurrentPageNumber({
	total,
	limit,
	rowCount,
}: {
	total: number
	limit: number
	rowCount: number
}) {
	if (rowCount) {
		return Math.max(1, Math.ceil(rowCount / limit))
	} else {
		return Math.max(1, Math.ceil(total / limit))
	}
}

export const getCurrentPage = (offset: number, limit: number): number => {
	return Math.max(offset / limit + 1, 1)
}

export const filterData = (items: any[], param: { [name: string]: string }) => {
	const defaultParamLength = 2 // default param object is {page: 1, limit: 10}
	if (Object.keys(param).length !== defaultParamLength) {
		return shuffle(items)
	} else {
		return items
	}
}

export interface PaginatedItem<T> {
	items?: T[]
	page?: number
	limit?: number
	loadMore?: boolean
	param?: { [name: string]: string }
}

export interface PaginatedItemResult<T> {
	data: T[]
	page: number
	limit: number
	total: number
}

export const getPaginatedItems = <T>({
	items = [],
	page = 1,
	limit = 10,
	loadMore = false,
	param = {},
}: PaginatedItem<T>): PaginatedItemResult<T> | [] => {
	let data: T[] = []
	if (!items) return []
	const total = items.length
	items = filterData(items, param)
	if (loadMore) {
		data = take(items, page * limit)
	} else {
		if (page * limit > total) return getPaginatedItems({ items, page: page - 1, limit })
		data = take(drop(items, (page - 1) * limit), limit)
	}

	return <PaginatedItemResult<T>>{
		data,
		page,
		limit,
		total,
	}
}
// export default getPaginatedItems;
